import React from 'react';
import MuiAccordion from '@mui/material/Accordion';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import KeyboardArrowDownOutlined from '@mui/icons-material/KeyboardArrowDownOutlined';
import { colorPalette } from '../../colorPalette';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import * as styles from './Accordion.style';
export const Accordion = (props) => {
    const { title, subTitle = '', children, icon, isLite = false, titleStyle = styles.titleStyle, summaryStyle, detailsStyle } = props;
    return (React.createElement(MuiAccordion, { disableGutters: true, elevation: 0, sx: isLite ? styles.customAccordionLiteStyle : styles.customAccordionClassicStyle },
        React.createElement(MuiAccordionSummary, { sx: [
                styles.customSummaryStyle(props),
                ...(Array.isArray(summaryStyle) ? summaryStyle : [summaryStyle]),
            ], expandIcon: React.createElement(KeyboardArrowDownOutlined, { htmlColor: colorPalette.gray700, style: { fontSize: '18px' } }) },
            React.createElement(Box, { sx: { width: '100%', display: 'flex', flexDirection: 'row' } },
                icon ? React.createElement(Box, { sx: styles.iconStyle(props) }, icon) : null,
                React.createElement(Box, { sx: styles.generalSummary },
                    React.createElement(Typography, { sx: titleStyle }, title),
                    subTitle ? React.createElement(Typography, { sx: styles.subTitleStyle }, subTitle) : null))),
        React.createElement(AccordionDetails, { sx: [
                styles.customAccordionDetailsStyle(props),
                ...(Array.isArray(detailsStyle) ? detailsStyle : [detailsStyle]),
            ] },
            React.createElement(Box, { sx: styles.detailsContent }, children))));
};
